import GastroAnamnesiPatologicaEdit from "./components/GastroAnamnesiPatologicaEdit.vue"
import GastroAnamnesiPatologicaView from "./components/GastroAnamnesiPatologicaView.vue"
import GastroAnamnesiPatologicaList from "./components/GastroAnamnesiPatologicaList.vue"

export default{
    GastroAnamnesiPatologicaEdit,
    GastroAnamnesiPatologicaView,
    GastroAnamnesiPatologicaList
}